import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import LoginPage from "./pages/Login";
import ChangePasswordPage from "./pages/ChangePassword";
import ForgotPasswordPage from "./pages/ForgotPassword";
import ResetPasswordPage from "./pages/ResetPassword";
import MFAChallenge from "./pages/MFAChallenge";
import CoreProducts from "./pages/CoreProducts";
import PremiumSpecial from "./pages/PremiumSpecial";
import OrderSummary from "./pages/OrderSummary";
import OrderSuccess from "./pages/OrderSuccess";
import SettingsSecurity from "./pages/SettingsSecurity";
import MyOrders from "./pages/MyOrders";
import AdminLanding from "./pages/AdminLanding";
import AdminCatalogue from "./pages/AdminCatalogue";
import AdminBackorders from "./pages/AdminBackorders";
import MyBackorders from "./pages/MyBackorders";
import OwnerOrders from "./pages/OwnerOrders";
import OwnerOrderDetail from "./pages/OwnerOrderDetail";
import AdminSmtpSettings from "./pages/AdminSmtpSettings";
import RequireAuth from "./pages/RequireAuth";
import "./App.css";

function Root() {
  const { user, sessionState, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (sessionState === "AWAITING_MFA") return <Navigate to="/mfa" replace />;
  if (sessionState === "AWAITING_PW_CHANGE") return <Navigate to="/change-password" replace />;
  return <Navigate to={user.role === "OWNER_ADMIN" ? "/admin" : "/portal/core"} replace />;
}

const AP_ROLES = ["AP_ORDERER","AP_VIEWER","AP_CUSTOMER_ADMIN"];

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/mfa" element={<MFAChallenge />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/portal" element={<Navigate to="/portal/core" replace />} />
            <Route path="/portal/core" element={<RequireAuth roles={AP_ROLES}><CoreProducts /></RequireAuth>} />
            <Route path="/portal/premium" element={<RequireAuth roles={AP_ROLES}><PremiumSpecial /></RequireAuth>} />
            <Route path="/portal/summary" element={<RequireAuth roles={AP_ROLES}><OrderSummary /></RequireAuth>} />
            <Route path="/portal/order/success/:orderId" element={<RequireAuth roles={AP_ROLES}><OrderSuccess /></RequireAuth>} />
            <Route path="/portal/settings/security" element={<RequireAuth roles={AP_ROLES}><SettingsSecurity /></RequireAuth>} />
            <Route path="/portal/orders" element={<RequireAuth roles={AP_ROLES}><MyOrders /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth roles={["OWNER_ADMIN"]}><AdminLanding /></RequireAuth>} />
            <Route path="/admin/catalogue" element={<RequireAuth roles={["OWNER_ADMIN"]}><AdminCatalogue /></RequireAuth>} />
            <Route path="/admin/backorders" element={<RequireAuth roles={["OWNER_ADMIN"]}><AdminBackorders /></RequireAuth>} />
            <Route path="/portal/backorders" element={<RequireAuth roles={AP_ROLES}><MyBackorders /></RequireAuth>} />
            <Route path="/admin/orders" element={<RequireAuth roles={["OWNER_ADMIN"]}><OwnerOrders /></RequireAuth>} />
            <Route path="/admin/orders/:orderId" element={<RequireAuth roles={["OWNER_ADMIN"]}><OwnerOrderDetail /></RequireAuth>} />
            <Route path="/admin/settings/smtp" element={<RequireAuth roles={["OWNER_ADMIN"]}><AdminSmtpSettings /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
